import { render, staticRenderFns } from "./MescladaCreate.vue?vue&type=template&id=a296f056&scoped=true"
import script from "./MescladaCreate.vue?vue&type=script&lang=js"
export * from "./MescladaCreate.vue?vue&type=script&lang=js"
import style0 from "./MescladaCreate.vue?vue&type=style&index=0&id=a296f056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a296f056",
  null
  
)

export default component.exports